'use client';

import { RouteError } from '@/components/error-boundary/route-error';

/** Outer net: catches errors that escape the (panel)/auth layouts. */
export default function LocaleError(props: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return <RouteError {...props} />;
}
